import { useEffect, useState } from 'react';
import { TeacherDetails } from './types';
import { createTeacherSearchAPIURL } from '../search/searchApi.js';
import { LoadingEllipsis } from '../common/LoadingEllipsis.js';
import { ProjectList } from '../common/ProjectList';

interface TeacherProfileProjectsBarProps {
    teacherDetails: TeacherDetails,
}

const MAX_ACTIVE_PROJECTS = 2;

const TeacherProfileProjectsBar = ({
    teacherDetails,
}: TeacherProfileProjectsBarProps) => {
    const hasActiveProjects = teacherDetails.numActiveProjects > 0;
    const [loading, setLoading] = useState(hasActiveProjects);
    const [activeProjects, setActiveProjects] = useState<object[]>();

    useEffect(() => {
        if (!hasActiveProjects) {
            return;
        }

        setLoading(true);
        $.ajax({
            type: 'GET',
            url: createTeacherSearchAPIURL(teacherDetails.id, 0, undefined, MAX_ACTIVE_PROJECTS, false),
            dataType: 'json',
            success: (response) => {
                const activeProposals = response.proposals;

                setActiveProjects(activeProposals);
                setLoading(false);
            },
            error: () => {
                setLoading(false);
            },
        });
    }, [teacherDetails.id, hasActiveProjects]);

    if (!hasActiveProjects) {
        return null;
    }

    if (loading || !activeProjects) {
        return (
            <div className="teacher-requests-loading" aria-busy="true">
                <LoadingEllipsis />
            </div>
        );
    }

    return (
        <div className="requests-list">
            <ProjectList
                projects={activeProjects}
                showGiveWidget={false}
            />
        </div>
    );
};

export default TeacherProfileProjectsBar;
